import {makeReactContext} from 'lib/makeReactContext';

export interface DocumentEditorContextData {
  documentParentId?: string;
  documentName?: string;
}

function getDocumentEditorContextFallback(): DocumentEditorContextData {
  return {
    documentParentId: undefined,
    documentName: undefined,
  };
}

const DocumentEditorContext = makeReactContext<DocumentEditorContextData>(
  getDocumentEditorContextFallback,
  'DocumentEditorContext'
);

export default DocumentEditorContext;
